import { Box, CardContent, Grid, Typography, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { memo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import icon1 from "../../../Images/svgs/dashboard-top-card/Projects.svg";
import icon2 from "../../../Images/svgs/dashboard-top-card/CrawlLimit.svg";
import icon3 from "../../../Images/svgs/dashboard-top-card/BlogGenerator.svg";
import icon4 from "../../../Images/svgs/dashboard-top-card/Reports.svg";
import icon5 from "../../../Images/svgs/dashboard-top-card/SiteAudit.svg";
import icon6 from "../../../Images/svgs/dashboard-top-card/Invitations.svg";
import icon7 from "../../../Images/svgs/dashboard-top-card/KeywordResearch.svg";
import icon8 from "../../../Images/svgs/dashboard-top-card/Organizations.svg";
import { GetScrapyData, GetTotalReportCount } from "../../../hooks/scrapyData";
import { AvailNotifications, FindUserById } from "../../../hooks/organization";
import useQuery from "../../../hooks/allQuery";
import { getOrgsByAdmin } from "../../../gql/queries/org";
import { projectDetails, usersCreditsYearly } from "../../../common/constant";
import { useUserSubscriptionDetails } from "../../../hooks/user";

function TopCards() {
  const theme = useTheme();
  const [topCards, setTopCards] = useState(null);
  const [orgData, setOrgData] = useState([]);
  const { userData } = useSelector(state => state.reducer);
  const { scrapyData } = GetScrapyData();
  const { reportCountData } = GetTotalReportCount();
  const { allQuery } = useQuery();
  const [GET_ORGNS] = useLazyQuery(getOrgsByAdmin, {
    fetchPolicy: "cache-first",
  });
  const { data } = FindUserById(userData?.id);
  const { subscriptionData } = useUserSubscriptionDetails();
  const { email } = userData || {};
  const { data: invitations } = AvailNotifications(email);
  const [loading, setLoading] = useState(true);

  const getOrganigationByAdmin = async () => {
    setLoading(true);
    allQuery({
      QUERY: GET_ORGNS,
      variables: {
        authorId: userData?.id,
      },
      onCompleteFunc: ({ findOrgByAdmin }) => {
        if (findOrgByAdmin?.success) {
          setOrgData(findOrgByAdmin?.Orgdata || []);
        }
        setLoading(false);
      },
      onErrorFunc: err => {
        setLoading(false);
      },
    });
  };
  useEffect(() => {
    if (userData?.id) getOrganigationByAdmin();
  }, [userData?.id]);
  useEffect(() => {
    if (scrapyData && orgData && data && invitations && subscriptionData) {
      setLoading(false);

      const subscriptionType = userData?.subscriptionCredits?.subscriptionType;
      setTopCards([
        {
          icon: icon1,
          title: "Projects",
          digits: loading
            ? "Loading..."
            : `${(userData?.subscriptionCredits?.totalProjects ?? 0) - (subscriptionData?.projects ?? 0)}/${userData?.subscriptionCredits?.totalProjects ?? 0}`,
          bgcolor: "#4DC0FF",
          Link: subscriptionType === "FREEMIUM" || (subscriptionData?.projects || 0) === 0 ? "/payments" : "/siteAudit?menu=headerSiteAudit",
          restrictedMessage: loading ? "" : (subscriptionData?.projects || 0) === 0 ? "Upgrade your plan to unlock more Projects capacity!" : "",
        },
        {
          icon: icon2,
          title: "Crawl limit",
          digits: loading
            ? "Loading..."
            : // eslint-disable-next-line no-unsafe-optional-chaining
              `${
                userData.userCrawlCredits !== undefined
                  ? // eslint-disable-next-line no-unsafe-optional-chaining
                    userData?.subscriptionCredits?.totalSiteAudit - userData?.userCrawlCredits.creditUpdated
                  : (userData?.subscriptionCredits?.totalSiteAudit || 0) - (subscriptionData?.siteAudit || 0)
              }/${userData?.subscriptionCredits?.totalSiteAudit ?? 0}`,

          bgcolor: "#FA896B",
          Link: subscriptionType === "FREEMIUM" || (subscriptionData?.siteAudit || 0) === 0 ? "/payments" : `/crawl-table/${userData?.id}?limit=${userData?.crawlLimit || 0}`,
          restrictedMessage: loading
            ? ""
            : (subscriptionData?.siteAudit || 0) === 0
            ? subscriptionData?.subscriptionType === "ENTERPRISES"
              ? "Limit reached! Please reach out to support for assistance."
              : "Upgrade your plan to unlock more Crawl limit capacity!"
            : "",
        },
        {
          icon: icon3,
          title: "Blog generator",
          digits: loading
            ? "Loading..."
            : `${(userData?.subscriptionCredits?.totalBlogGeneration || 0) - (subscriptionData?.blogGeneration || 0)}/${userData?.subscriptionCredits?.totalBlogGeneration ?? 0}`,
          bgcolor: "#13DEB9",
          Link: subscriptionType === "FREEMIUM" || (subscriptionData?.blogGeneration || 0) === 0 ? "/payments" : "/ai-blog-generator?menu=headerAiBlogGenerator",
          restrictedMessage: loading ? "" : (subscriptionData?.blogGeneration || 0) === 0 ? "Upgrade your plan to unlock more Blog Generation capacity!" : "",
        },
        {
          icon: icon4,
          title: "Reports",
          digits: loading ? "Loading..." : reportCountData,
          bgcolor: "#bea6e1",
        },
        {
          icon: icon5,
          title: "Site audit",
          digits: loading
            ? "Loading..."
            : `${
                userData.userCrawlCredits !== undefined
                  ? // eslint-disable-next-line no-unsafe-optional-chaining
                    userData?.subscriptionCredits?.totalSiteAudit - userData?.userCrawlCredits.creditUpdated
                  : (userData?.subscriptionCredits?.totalSiteAudit || 0) - (subscriptionData?.siteAudit || 0)
              }/${userData?.subscriptionCredits?.totalSiteAudit ?? 0}`,
          bgcolor: "#65ff60",
          Link:
            subscriptionType === "FREEMIUM" || (subscriptionData?.siteAudit || 0) === 0
              ? "/payments"
              : `/siteAudit?menu=headerSiteAudit${userData?.id}?limit=${userData?.crawlLimit || 0}`,
          restrictedMessage: loading
            ? ""
            : (subscriptionData?.siteAudit || 0) === 0
            ? subscriptionData?.subscriptionType === "ENTERPRISES"
              ? "Limit reached! Please reach out to support for assistance."
              : "Upgrade your plan to unlock more Site audit capacity!"
            : "",
        },
        {
          icon: icon7,
          title: "Keyword research",
          digits: loading
            ? "Loading..."
            : `${(userData?.subscriptionCredits?.totalKeywordResearch || 0) - (subscriptionData?.keywordResearch || 0)}/${
                userData?.subscriptionCredits?.totalKeywordResearch ?? 0
              }`,
          bgcolor: "#FFAF22",
          Link: subscriptionType === "FREEMIUM" || (subscriptionData?.keywordResearch || 0) === 0 ? "/payments" : "/keyword-reserch?menu=headerKeywordReserch",
          restrictedMessage: loading ? "" : (subscriptionData?.keywordResearch || 0) === 0 ? "Upgrade your plan to unlock more Keyword Research capacity!" : "",
        },
        {
          icon: icon6,
          title: "Invitations",
          digits: "Coming Soon",
          bgcolor: "#d3d412",
        },
        {
          icon: icon8,
          title: "Organization",
          digits: "Coming Soon",
          bgcolor: "#b69a34",
        },
      ]);
    }
  }, [scrapyData, orgData, data, invitations, reportCountData, subscriptionData, userData]);
  return (
    topCards && (
      <Grid container spacing={2} mt={0}>
        {topCards.map(topcard => (
          <Grid item xs={12} sm={4} lg={3} key={topcard.title}>
            {topcard?.Link ? (
              <Link to={topcard?.Link}>
                <Box
                  textAlign="center"
                  sx={{
                    height: "100%",
                    borderRadius: "7px",
                    backgroundColor: topcard.bgcolor + "2b",
                    scale: "1",
                    transition: "all 1s ease",
                    "&:hover": {
                      boxShadow: "inset 0 0 3px 3px" + topcard.bgcolor,
                      "& .cardConteentWrapper": { scale: "1.05" },
                    },
                    "& *": { transition: "all 1s ease" },
                  }}
                >
                  <CardContent
                    className="cardConteentWrapper"
                    sx={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "16px", padding: "30px 14px !important" }}
                  >
                    <img src={topcard.icon} alt="topcard.icon" width="50" />
                    <Box>
                      <Typography sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#000000" }} variant="h5" fontWeight={700} lineHeight={1} mb="8px">
                        {topcard?.digits}
                      </Typography>
                      <Typography sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#000000" }} variant="subtitle1" fontWeight={600} lineHeight={1}>
                        {topcard.title}
                      </Typography>

                      {topcard.restrictedMessage && (
                        <Typography variant="body2" color="error" fontWeight={500} mt={1}>
                          {topcard.restrictedMessage}
                        </Typography>
                      )}
                    </Box>
                  </CardContent>
                </Box>
              </Link>
            ) : (
              <a href={topcard.href}>
                <Box textAlign="center" sx={{ height: "100%", borderRadius: "7px", backgroundColor: topcard.bgcolor + "2b" }}>
                  <CardContent sx={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "16px", padding: "30px 14px !important" }}>
                    <img src={topcard.icon} alt="topcard.icon" width="50" />
                    <Box>
                      <Typography sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#000000" }} variant="h5" fontWeight={700} lineHeight={1} mb="8px">
                        {topcard?.digits}
                      </Typography>
                      <Typography sx={{ color: theme.palette.mode === "dark" ? "#ffffff" : "#000000" }} variant="subtitle1" fontWeight={600} lineHeight={1}>
                        {topcard.title}
                      </Typography>
                    </Box>
                  </CardContent>
                </Box>
              </a>
            )}
          </Grid>
        ))}
      </Grid>
    )
  );
}

export default memo(TopCards);
